/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
__webpack_public_path__ = window._webpack_resource_base;

delete window._webpack_resource_base;
